module.exports = __webpack_public_path__ + "static/media/wedding07.36b66c16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding07.jpg
// module id = 427
// module chunks = 0